import { DialogElement } from '@@types/Dialog';

import { isNumber } from 'lodash';
import { allPass, equals, includes } from 'ramda';
import always from 'ramda/es/always';
import append from 'ramda/es/append';
import groupBy from 'ramda/es/groupBy';
import head from 'ramda/es/head';
import juxt from 'ramda/es/juxt';
import map from 'ramda/es/map';
import mergeAll from 'ramda/es/mergeAll';
import objOf from 'ramda/es/objOf';
import pick from 'ramda/es/pick';
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import ramdaUseWith from 'ramda/es/useWith';
import when from 'ramda/es/when';

const subTypeRules = ['number', 'tel', 'url', 'email'];

export const makeRules = ({ type, subtype, optional, minLength, maxLength }: DialogElement) => {
  return pipe(
    when(always(!Boolean(optional)), append('required')),
    when(always(isNumber(maxLength)), append(`max:${maxLength}`)),
    when(always(isNumber(minLength)), append(`min:${minLength}`)),
    when(allPass([always(equals('text', type)), always(includes(subtype, subTypeRules))]), append(subtype)),
    objOf('rules')
  )([]);
};

export const makeField = (dialogElement: DialogElement) => {
  return pipe(juxt([pick(['name', 'placeholder', 'value']), makeRules]), mergeAll)(dialogElement);
};

export const makeFields = (elements: DialogElement[]) => {
  return map(makeField, elements);
};

export const extractInitialValues = (elements: DialogElement[]) => {
  return pipe<any, any, any>(groupBy<DialogElement>(prop('name')), map(ramdaUseWith(prop('value'), [head])))(elements);
};
